<template>
  <standard-dialog
    v-model="model"
    :title="user ? `${user.name} ${user.lastname}` : $t('user')"
    icon="mdi-account"
    max-width="550"
    hide-actions
  >
    <div v-if="user" class="user-details">
      <!-- Basic Info Card -->
      <v-card outlined class="mb-4">
        <v-card-text class="pa-4">
          <!-- Contact Information -->
          <v-row>
            <v-col cols="6">
              <div class="info-row d-flex align-center">
                <v-icon small color="orange" class="mr-3">mdi-phone</v-icon>
                <div class="flex-grow-1">
                  <div class="text-caption grey--text">{{ $t("phone") }}</div>
                  <div class="text-body-2">{{ user.phone || "-" }}</div>
                </div>
              </div>
            </v-col>
            <v-col cols="6">
              <div class="info-row d-flex align-center">
                <v-icon small color="orange" class="mr-3">mdi-email</v-icon>
                <div class="flex-grow-1">
                  <div class="text-caption grey--text">{{ $t("email") }}</div>
                  <div class="text-body-2">{{ user.email || "-" }}</div>
                </div>
              </div>
            </v-col>
          </v-row>

          <!-- Location Info -->
          <template v-if="userLocation">

            <v-row>
              <v-col cols="6">
                <div class="info-row d-flex align-center">
                  <v-icon small color="orange" class="mr-3">mdi-home</v-icon>
                  <div class="flex-grow-1">
                    <div class="text-caption grey--text">{{ $t("address") }}</div>
                    <div class="text-body-2">{{ userLocation.address || "-" }}</div>
                  </div>
                </div>
              </v-col>
              <v-col cols="6">
                <div class="info-row d-flex align-center">
                  <v-icon small color="orange" class="mr-3">mdi-city</v-icon>
                  <div class="flex-grow-1">
                    <div class="text-caption grey--text">{{ $t("city") }}</div>
                    <div class="text-body-2">
                      {{ userLocation.city ? userLocation.city.name : "-" }}
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col v-if="userLocation.apartment" cols="6">
                <div class="info-row d-flex align-center">
                  <v-icon small color="orange" class="mr-3">mdi-door</v-icon>
                  <div class="flex-grow-1">
                    <div class="text-caption grey--text">{{ $t("apartment") }}</div>
                    <div class="text-body-2">{{ userLocation.apartment }}</div>
                  </div>
                </div>
              </v-col>
              <v-col v-if="userLocation.floor" cols="6">
                <div class="info-row d-flex align-center">
                  <v-icon small color="orange" class="mr-3">mdi-stairs</v-icon>
                  <div class="flex-grow-1">
                    <div class="text-caption grey--text">{{ $t("floor") }}</div>
                    <div class="text-body-2">{{ userLocation.floor }}</div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </template>
        </v-card-text>
      </v-card>
    </div>
  </standard-dialog>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import StandardDialog from "@/components/dialogs/StandardDialog.vue";
import { transactionsTotal } from "@/utils/guestOrderTotal";

export default {
  name: "GuestUserDetailsDialog",
  mixins: [hasModel],
  props: {
    user: {
      type: Object,
      default: null,
    },
  },
  components: {
    StandardDialog,
  },
  computed: {
    userLocation() {
      // Get location from first order if available
      if (
        this.user &&
        this.user.orders_guest &&
        this.user.orders_guest.length > 0 &&
        this.user.orders_guest[0].location
      ) {
        return this.user.orders_guest[0].location;
      }
      return null;
    },
  },
  methods: {
    formatDateTime(dateTime) {
      if (!dateTime) return "";
      return new Date(dateTime).toLocaleString("sr-Latn", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    getStatusColor(status) {
      const colors = {
        pending: "orange",
        accepted: "blue",
        "in-progress": "cyan",
        ready: "purple",
        "on-hold": "grey",
        delivered: "green",
        completed: "green",
        cancelled: "red",
        "support-canceled": "red",
        rejected: "red",
        deleted: "red",
      };
      return colors[status] || "grey";
    },
    calculateOrderTotal(order) {
      if (!order.order_guest_transactions) return 0;

      return transactionsTotal(order.order_guest_transactions);
    },
  },
};
</script>

<style scoped>
.user-details {
  max-height: 70vh;
  overflow-y: auto;
}

.info-section {
  padding-left: 4px;
}

.info-row {
  min-height: 48px;
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.order-item {
  background-color: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
}

.order-item:last-child {
  margin-bottom: 0 !important;
}

.transactions-list {
  padding: 8px 0;
}
</style>
